// extracted by mini-css-extract-plugin
module.exports = {"check":"SuccessIcon_check__XGCAv"};